import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./icon.html";
export let SizeTypes = /*#__PURE__*/function (SizeTypes) {
  SizeTypes["XSmall"] = "xsmall";
  SizeTypes["Small"] = "small";
  SizeTypes["Medium"] = "medium";
  SizeTypes["Large"] = "large";
  SizeTypes["XLarge"] = "xlarge";
  return SizeTypes;
}({});
export let VariantTypes = /*#__PURE__*/function (VariantTypes) {
  VariantTypes["Inverse"] = "inverse";
  VariantTypes["Success"] = "success";
  VariantTypes["Warning"] = "warning";
  VariantTypes["Info"] = "info";
  VariantTypes["Error"] = "error";
  VariantTypes["Parent"] = "parent";
  VariantTypes["Current"] = "current";
  return VariantTypes;
}({});
export let SpriteTypes = /*#__PURE__*/function (SpriteTypes) {
  SpriteTypes["Appexchange"] = "appexchange";
  return SpriteTypes;
}({});
class Icon extends LightningElement {
  constructor(...args) {
    super(...args);
    this.description = void 0;
    this.size = SizeTypes.Small;
    this.sprite = SpriteTypes.Appexchange;
    this.symbol = 'info';
    this.variant = void 0;
    this.spriteUrl = './icons/ads/icons.svg';
    this._gradiant = {
      color: this.fill,
      percent: '50%',
      empty: 'white'
    };
    this._setGradiant = false;
  }
  get href() {
    return `${this.spriteUrl}#${this.symbol}`;
  }
  get className() {
    return `size--${this.size} variant--${this.variant}`;
  }
  renderedCallback() {
    if (this._setGradiant) {
      const linearGradient = this.template.querySelector('linearGradient');
      if (linearGradient) {
        //this.fill = 'url(#' + linearGradient.id + ')'; // eslint-disable-line @lwc/lwc/no-api-reassignments
        this.template.host.style.setProperty('--ads-icon_fill', `url(#${linearGradient.id})`);
      }
      this._setGradiant = false;
    }
  }
  set gradient(gradiant) {
    this._gradiant = gradiant;
    this._setGradiant = true;
  }
  get gradient() {
    return this._gradiant;
  }
  set width(size) {
    this.template.host.style.setProperty('--ads-icon-width', size);
  }
  get width() {
    return this.template.host.style.getPropertyValue('--ads-icon-width');
  }
  set height(size) {
    this.template.host.style.setProperty('--ads-icon-height', size);
  }
  get height() {
    return this.template.host.style.getPropertyValue('--ads-icon-height');
  }
  set fill(color) {
    this.template.host.style.setProperty('--ads-icon_fill', color);
  }
  get fill() {
    return this.template.host.style.getPropertyValue('--ads-icon_fill');
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Icon, {
  publicProps: {
    description: {
      config: 0
    },
    size: {
      config: 0
    },
    sprite: {
      config: 0
    },
    symbol: {
      config: 0
    },
    variant: {
      config: 0
    },
    spriteUrl: {
      config: 0
    },
    gradient: {
      config: 3
    },
    width: {
      config: 3
    },
    height: {
      config: 3
    },
    fill: {
      config: 3
    }
  },
  fields: ["_gradiant", "_setGradiant"]
});
const __lwc_component_class_internal = _registerComponent(Icon, {
  tmpl: _tmpl,
  sel: "ads-icon",
  apiVersion: 62
});
export default __lwc_component_class_internal;